export const ANALYTICS_DESTINATIONS = [
  { section: "overview", label: "Overview", group: "Reports", permission: "/admin/analytics" },
  { section: "growth", label: "Revenue", group: "Reports", permission: "/admin/analytics" },
  { section: "customers", label: "Customers", group: "Reports", permission: "/admin/analytics/customers" },
  { section: "sales", label: "Sales", group: "Reports", permission: "/admin/analytics/sales" },
  { section: "operations", label: "Operations", group: "Reports", permission: "/admin/analytics/operations" },
  { section: "demand", label: "Leads & conversion", group: "Acquisition", permission: "/admin/analytics/demand" },
  { section: "ads", label: "Ads overview", group: "Acquisition", permission: "/admin/ads" },
  { section: "google-ads", label: "Google Ads", group: "Acquisition", permission: "/admin/ads" },
  { section: "meta-ads", label: "Meta Ads", group: "Acquisition", permission: "/admin/ads" },
  { section: "funnel", label: "Paid funnel", group: "Acquisition", permission: "/admin/ads" },
  { section: "tracking", label: "Conversion tracking", group: "Diagnostics", permission: "/admin/analytics/demand" },
  { section: "sources", label: "Ad data sources", group: "Diagnostics", permission: "/admin/ads" },
] as const;

export function analyticsDestinationHref(section: string) {
  return `/admin/analytics?view=${section}`;
}

export function analyticsWorkspaceHref(query: string, section: string) {
  const params = new URLSearchParams(query);
  for (const key of ["tab", "section", "campaign", "account", "channel", "from"]) params.delete(key);
  params.set("view", section);
  return `/admin/analytics?${params.toString()}`;
}
